<template>

    <van-form class="container" @submit="onSubmit" >

        <div class="container zx-fill-ticket-info">

            <div class="header f-s-b">
                <div class="header-item header-item-active theme-color-font">填写预约信息</div>
                <div class="header-item item-line " ></div>
                <div class="header-item">预约成功</div>
            </div>

            <div class="body ">
                
                <!-- 预约信息 -->
                <ul class="body-rander-item ">
                    <li class="row-box info-row info-title ">
                        <div class="inner-row f-s-b">
                            <div class="info-left f-c">
                                <i class="iconhebei iconshenqing theme-color-font icon-size"></i>
                                <span>{{getDetailInfo.activityName}}</span>
                            </div>
                            <!-- <div class="info-right f-c ellipsis theme-color-font g-b-500">
                                入园须知>
                            </div> -->
                        </div>
                    </li>
                    <li class="row-box info-row f-c">
                        <i class="iconhebei iconshizhong g-yellow-color"></i>
                        <span class="left-txt f-s-b">
                            <span v-for="(item, index) in [ '活', '动' ,'时', '间' ]" :key="index">{{item}}</span>
                        </span>
                        <span class="right-txt">: {{getDetailInfo.dateStr}}</span>
                    </li>
                    <li class="row-box info-row f-c">
                        <i class="iconhebei iconnianling g-green-color"></i>
                        <span class="left-txt f-s-b">
                            <span v-for="(item, index) in [ '报', '名', '条', '件' ]" :key="index">{{item}}</span>
                        </span>
                        <span class="right-txt">: {{getDetailInfo.requirements}}</span>
                    </li>

                    <!-- <li class="row-box info-row f-c">
                        <i class="iconhebei iconprice g-yellow-color"></i>
                        <span class="left-txt f-s-b">
                            <span v-for="(item, index) in [ '费', '用' ]" :key="index">{{item}}</span>
                        </span>
                        <span class="right-txt">: 免费</span>
                    </li>
                    <li class="row-box info-row f-c">
                        <i class="iconhebei iconrenshu g-violet-color"></i>
                        <span class="left-txt f-s-b">
                            <span v-for="(item, index) in [ '报', '名', '限', '制' ]" :key="index">{{item}}</span>
                        </span>
                        <span class="right-txt">: 1大1小</span>
                    </li> -->

                </ul>

                <div class="contacts-title-box f-s-b g-b-500">
                    <div>
                        <span>联系人</span>
                    </div>
                </div>

                <ul class="body-rander-item explain-home-info-input">
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.name"
                            :name="`name`"
                            :border="false"
                            readonly
                            disabled
                            label="姓名"
                            placeholder="请输入联系人姓名"
                        />
                            <!-- :rules="[{ required: true, message: '请正确填写联系人姓名', validator: checkName }]" -->
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.phone"
                            type="tel"
                            maxlength="11"
                            name="phone"
                            :border="false"
                            readonly
                            disabled
                            label="手机号"
                            placeholder="请输入联系人手机号"
                        />
                            <!-- :rules="[{ required: true, message: '请正确填写联系人手机号', validator: checkPhone }]" -->
                    </li>
                    <li class="row-box">
                        <van-field
                            class="item-row f-s-b user-name"
                            v-model.trim="contactsInfo.id"
                            maxlength="18"
                            name="id"
                            :border="false"
                            readonly
                            disabled
                            label="身份证"
                            placeholder="请输入联系人身份证"
                        />
                            <!-- :rules="[{ required: true, message: '请正确填写联系人身份证', validator: checkPhone }]" -->
                    </li>
                </ul>

            </div>

            <div class="foot f-c">
                <van-button class="btn f-c" block type="info" native-type="submit">
                    {{btnTxt}}
                </van-button>
            </div>

        </div>

        <div hidden style="width:0;height:0;">{{getUserInfo}}</div>

    </van-form>

</template>

<script>
    import util from '@util';
    import { 
        Field,
        Form, 
        Button,
    } from 'vant';
    import {
        commitVolunteerActivityUrl,
    } from '@js/volunteerUrl.js';
    import http from '@js/http-zyz.js';
    export default {
        data() {
            return {
                phonePattern: /^1[3456789]\d{9}$/,
                idPattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                imageList:[require('@image/home/21321321.png'),],
                contactsInfo: {
                    name: '',
                    phone: '',
                    id: '',
                },
                flag: false,
                btnTxt: '确认报名',
            }
        },
        created() {
        },
        methods: {
            onSubmit(values) {
                // console.log('submit', values);
                if(values) {
                    this.commit();
                    // this.$router.push({ name: 'volunteerSuccess'})
                }
            },
            commit(){
                http.post(commitVolunteerActivityUrl,{
                    activityId: this.getDetailInfo.id,
                    userName: this.getUserInfo.userName,
                    idcard: this.getUserInfo.idcard,
                    phone: this.getUserInfo.phone,
                }).then(res=>{
                    var {
                        data:{
                            success = false
                        }
                    } = res;
                    if(success){
                        this.$router.push({ name: 'volunteerSuccess'})
                    }
                })
            },
            checkName(v){
                return /^[\u4e00-\u9fa5_a-zA-Z]{2,10}$/.test(v)
                // return v === ""? false : true;
            },
            onChangeNumber(type = 'narratorNumber',flag = true){
                return ()=>{
                    if(flag){
                        this[type]++
                    }else{
                        if(this[type]>1) {
                            this[type]--;
                        }
                    }
                }
            },
            checkPhone(v){
                return this.phonePattern.test(v)
                // return new Promise(resolve => {
                //     this.$toast.loading({
                //         forbidClick: true,
                //         message: '验证中...'
                //     });
                //     setTimeout(() => {
                //         this.$toast.clear();
                //         resolve(this.phonePattern.test(v));
                //     }, 700);
                // });
            },
            checkId(v){
                return this.idPattern.test(v);
            },
        },  
        computed: {
            getUserInfo(){
                var info = this.$store.state.userInfo.info || false;
                if(info){
                    this.contactsInfo.name = info.userName;
                    this.contactsInfo.phone = info.phone;
                    this.contactsInfo.id = info.idcard;
                }
                return info;
            },
            getDetailInfo(){
                // 活动状态（1-未开始，2-报名中，3-已结束；code：activity_status）	
                var info = this.$store.state.tempTransmitParams || {};
                if(info.activityStaTime){
                    if(info.canEntryNum > 0 && info.activityStatus === 2){
                        this.flag = true;
                    }else if(info.canEntryNum < 0){
                        this.btnTxt = '活动人员已满';
                    }else if(info.activityStatus === 1){
                        this.btnTxt = '活动暂未开始';
                    }else if(info.activityStatus === 3){
                        this.btnTxt = '活动已结束';
                    }
                    info.dateStr = `${util.formatTime(new Date(info.activityStaTime), "时分秒")} - ${util.formatTime(new Date(info.activityEndTime), "时分秒")}`
                }
                return info;
            }
        },     
        components:{
            [Field.name]: Field,
            [Form.name]: Form,
            [Button.name]: Button,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        // height: ~"calc(100% - 50px)" !important;
        // padding-bottom: 50px;
        .header{
            position: relative;
            padding: 0 35px 0 65px;
            box-sizing: border-box;
            background-color: #ffffff;
            height: 56px;
            color: #9C9C9C;
            .header-item{
                white-space: nowrap;
                width: auto;
                position: relative;
                text-align: center;
            }
            .item-line{
                width: 30%;
                border-bottom: 1px dotted #9C9C9C;
            }
            .header-item-active{
                margin-left: -25px;
                &::before{
                    background-color: #4282FF;
                    content: '';
                    border-radius: 2px;
                    height: 5px;
                    width: 65px;
                    position: absolute;
                    bottom: -10px;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }

        .body{
            margin-bottom: 10px;
            padding: 7px;
            .body-rander-item{
                background-color: #ffffff;
                overflow: hidden;
                border-radius:5px;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                margin-bottom: 7px;
                .row-box{
                    position: relative;
                    box-sizing: border-box;
                    height: 50px;
                    padding: 0 12px;
                    background-color: #ffffff;
                    &:last-child{
                        .item-row{
                            border: 0;
                        }
                    }
                    .item-row{
                        border-bottom: .5px solid #CBCBCB;
                        height: 100%;
                        background-color: transparent;
                        font-size: 14px;
                    }
                    .right-control{
                        color: #9599A2;
                        position: absolute;
                        top: 50%;
                        overflow: hidden;
                        transform: translateY(-50%);
                        left: 90px;
                        right: 12px;
                        .icon-size{
                            &::before{
                                font-weight: 500;
                            }
                        }
                    }
                    .number-control{
                        justify-content: flex-start;
                        .number-box{
                            margin: 0 10px;
                            display: inline-flex;
                            vertical-align: top;
                            width:65px;
                            height:22px;
                            box-sizing: border-box;
                            border:1px solid rgba(212,212,212,1);
                        }
                        .number-icon-size{
                            &::before{
                                font-size: 20px;
                                font-weight: 500;
                            }
                        }
                    }
                }
                .info-row{
                    padding-top: 10px;
                    padding-bottom: 10px;
                    align-items: baseline;
                    height: auto;
                    justify-content: flex-start;
                    font-size: 12px;
                    color: #979899;
                    .left-txt{
                        margin-left: 12px;
                        width: 80px;
                        text-align-last: justify;
                        color: #61666C;
                        font-weight: 500;
                    }
                    .right-txt{
                        width: ~"calc(100% - 85px)";
                    }
                }
                .info-title{
                    padding-left: 0;
                    padding-right: 0;
                    margin: 0 12px;
                    border-bottom: .5px solid #CCCCCC;

                    align-items: baseline;
                    justify-content: space-between;
                    .inner-row{
                        align-items: baseline;
                    }
                    .info-left{
                        justify-content: flex-start;
                        // max-width: ~"calc(100% - 120px)";
                        width: 100%;
                        font-size:14px;
                        font-weight:500;
                        color:rgba(67,68,70,1);
                        .icon-size{
                            margin-right: 10px;
                            height: 20px;
                            box-sizing:border-box; 
                            &::before{
                                font-size: 20px;
                                display: inline-block;
                                vertical-align: top;
                            }
                        }
                    }
                    .info-right{
                        font-size: 14px;
                        display: block;
                        max-width: 130px;
                        .count{
                            font-size: 17px;
                            margin-left: 3px;
                        }
                    }
                }
            }
            .body-container{
                position: relative;
                border-radius:5px;
                overflow: hidden;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                background-size: 118px 142px;
                background-repeat: no-repeat;
                background-position: right 70%;
                background-image: url('../../lib/image/home/567.png');
                background-color:rgba(255,255,255,1);
                box-sizing: border-box;
                width: 100%;
                padding: 14px 30px;
                font-size: 12px;
                color: #565656;
                height: auto;
                &{
                    .item:last-child{
                        margin: 0;
                    }
                }
                .title{
                    text-align: center;
                    color: #242424;
                    font-size: 16px;
                }
                .small-title{
                    font-size: 14px;
                    color: #565656;
                }
                .body-iamge{
                    width: 100%;
                    margin: 10px 0;
                }
                .item{
                    margin-bottom: 10px;
                }
                .time{
                    padding-left: 9px;
                    letter-spacing: 1px;
                }
            }
            .contacts-title-box{
                padding-left: 12px;
                height: 50px;
                font-size: 14px;
                color: #555555;
                // justify-content: flex-start;
                .icon-size{
                    margin-right: 5px;
                    &::before{  
                        // font-size: 22px;
                    }
                }
                .look-narrators{
                    border: 0;
                    padding: 3px 6px;
                    font-size: 15px;
                    color:rgba(255,255,255,1);
                    background:rgba(92,162,253,1);
                    border-radius:3px;
                }
            }
        }

        .foot{
            background-color: #f0f1f4;
            // position: fixed;
            // bottom: 0;
            // left: 0;
            // right: 0;
            height: 50px;
            .btn{
                border: 0;
                font-size: 15px;
                color:rgba(255,255,255,1);
                width:332px;
                height:50px;
                background:rgba(92,162,253,1);
                border-radius:12px;
            }
        }

        .language-box{
            box-sizing: border-box;
            padding: 50px;
            flex-direction: column;
            .language{
                width: 100%;
            }
            .language-row{
                width: 100%;
                height: 40px;
            }
        }
    }
</style>